import { jsx } from "react/jsx-runtime";
import { Box, Anchor } from "@zillow/constellation-10";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
import DropdownMenu from "./DropdownMenu.esm.js";
const DropdownMenuItem = ({
  item
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const handleItemClick = (item2) => {
    sendEvent("cms_anchor", item2.label, item2.url, cmsInfo);
  };
  return /* @__PURE__ */ jsx(Box, { asChild: true, children: /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Anchor, { href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: yieldCallback(() => {
    handleItemClick(item);
  }), css: {
    display: "block",
    textDecoration: "none",
    textStyle: "body-sm",
    fontWeight: "normal",
    color: "text.link.default",
    paddingBlock: "tighter",
    paddingInline: "default",
    xl: {
      whiteSpace: "nowrap",
      width: "100%"
    },
    xlDown: {
      width: "100%"
    },
    _visited: {
      color: "text.link.default"
    },
    _hover: {
      textDecoration: "underline",
      color: "text.link.hover",
      backgroundColor: "blue.100"
    },
    _focusVisible: {
      textDecoration: "underline",
      color: "text.link.hover",
      backgroundColor: "blue.100"
    }
  }, children: item.label }) }) });
};
const Dropdown = ({
  submenus,
  dropdown
}) => {
  return /* @__PURE__ */ jsx(DropdownMenu, { isOpen: dropdown, children: submenus.map((submenu, index) => /* @__PURE__ */ jsx(DropdownMenuItem, { item: submenu }, index)) });
};
export {
  Dropdown as default
};
